import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 w-full px-4 md:px-6 py-20 flex items-center justify-center">
        <div className="text-center max-w-xl mx-auto">
          <span className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary-100 text-primary-600 font-heading font-bold text-3xl">
            404
          </span>
          <h1 className="mt-6 text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Page not found
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            The page you are looking for does not exist or may have been moved.
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold text-sm cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-5-line" />
            {t("nav_home")}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}